import Cookies from 'js-cookie'

const ActiveSendMenuKey = 'Admin-ActiveSendMenu'
const ActiveMenuKey = 'Admin-ActiveMenu'

export function getActiveMenu () {
  return Cookies.get(ActiveMenuKey)
}
export function setActiveMenu (info) {
  return Cookies.set(ActiveMenuKey, info)
}
export function removeActiveMenu () {
  return Cookies.remove(ActiveMenuKey)
}

export function getActiveSendMenu () {
  return Cookies.get(ActiveSendMenuKey)
}
export function setActiveSendMenu (info) {
  return Cookies.set(ActiveSendMenuKey, info)
}
export function removeActiveSendMenu () {
  return Cookies.remove(ActiveSendMenuKey)
}
